<template>
  <div style="padding-top: 3vw;">
    <div class="search" >
      <i class="el-icon-search"></i>
      <i class="glyphicon del"></i>
      <input ref="inputRef" @blur="handleblur" style="position: absolute;top: 1.7vw;left: 32%;background-color: #f6f6f6;width: 50%;" type="text" @input="handleInput()" v-model="mytext" placeholder="搜索你想了解的病种" >
    </div>
   
        <ul style="padding: 5vw;" v-if="this.mytext != ''">
            <li style="padding: 3vw 0vw;" v-for="item in list" :key="item" @click="details(item)">
              <i class="el-icon-search"></i>
                {{item}}
            </li>
        </ul>
        <div style="font-size: 5vw;text-align: center;margin-top: 40vw;" v-if="mytext != '' && list.length == 0">
            暂无数据
        </div>       
  </div>
</template>
<script>
import { illnessall } from '@/api/activity'
export default {
  data() {
    return {
      list: [],
      mytext: ''
    };
  },
  computed: {
		scrollHeight() {
	      return document.documentElement.scrollTop ||
	        window.pageYOffset ||
	        document.body.scrollTop || 0;
	    }
	},
  mounted() {
    this.$nextTick(() => {
      this.$refs.inputRef.focus();
      // const inputElement = this.$refs.inputRef;
      // if (inputElement) {
      //   inputElement.focus(); // 聚焦输入框
      //   // 你可以在这里获取input的值：
      //   console.log(inputElement.value);
      // }
    });
    this.getData()
  },
  beforeCreate() {
    document
      .querySelector("#app")
      .setAttribute("style", "background-color:#ffffff");
  },
  methods: {
    handleblur() {
	      window.scrollTo(0, Math.max(this.scrollHeight - 1, 0));
	    },
    details(item) {
      console.log(item)
      this.$router.push({
              path: "/screendetail",
              query:{
                name:item
              }
            });
    },
    handleInput(){
        console.log("input",this.mytext)
        if(this.list.length == 0) {
          this.getData()
        }
        this.list=this.list.filter(item=>item.includes(this.mytext))//筛选出来包含输入框值的元素
        //然后赋值给原数组，因为filter不会改变原数组，所以要用赋值的办法使得原数组改变，进而改变dom
    },
    getData() {
      document
      .querySelector("#app")
      .setAttribute("style", "background-color:#ffffff");
      illnessall().then((res)=>{
        this.list = res.data
        console.log(res)
      })
    },
  },
};
</script>
<style scoped>
* {
  margin: 0 auto;
  padding: 0;
  font-family: "微软雅黑";
}
.clearboth::after {
  content: "";
  display: block;
  clear: both;
}
.tab-slider {
  display: flex;
  min-height: 94vh;
  width: 100%;
  margin-top: 5vw;
  padding-top: 2vw;
  border-top: 1px solid #f6f6f6;
  /* margin: 50px auto; */
}
.tab-slider .tab {
  height: 94vh;
    overflow: auto;
  width: 30%;
  /* display:flex; */
  /* height:40px; */
  line-height: 40px;
  background: #f6f6f6;
}
.tab-slider .tab span {
  display: block;
  width: 100%;
  text-align: center;
  cursor: default;
}
.tab-slider .tab .active {
  background: #ffffff;
  text-align: center;
  font-weight: 700;
}
.tab-slider .tab-content {
  min-height: 94vh;
  height: 94vh;
    overflow: auto;
  width: 80%;
  /* overflow: hidden; */
}
.tab-slider .tab-content .item {
  float: left;
  /* height: 300px;
  width: 400px;
  line-height: 300px;
  text-align: center;
  font-size: 60px;
  background: #eee; */
}
.tab-slider .wrapbox {
  width: 100%;
  /* transition: all 1s; */
}
.search {
  position: relative;
    color: gray;
    border: 1px solid #f6f6f6;
    background-color: #f6f6f6;
    border-radius: 100px;
    height: 9vw;
    line-height: 9vw;
    width: 90%;
    margin: 2vw auto;
    overflow: hidden;
    padding: 0vw 20vw;
}

.search div {
  margin-left: 30px;
  margin-right: 30px;
}

input {
  margin-top: 1px;
  width: 100%;
  outline: none;
  border: none;
}

.icon {
  display: block;
  position: absolute;
  top: 5px;
  left: 10px;
  width: 20px;
  color: currentcolor;
  float: left;
}

.del {
  display: block;
  position: absolute;
  top: 5px;
  right: 10px;
  color: currentcolor;
  float: right;
}
</style>


// WEBPACK FOOTER //
// src/views/see.vue